<template>
    <div class="MonthlySchedulerPlanner">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Month Planner" name="month_planner">
                <!-- Action header -->
                <div v-if="!table_loader" class="card">
                    <el-row style="display: flex; align-items: center;" class="nymbl-tbl-header">
                        <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                            <el-row style="display: flex; align-items: center;">
                                <el-col style="margin: 0px 10px;" :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                    <!-- Select Store Select Box -->
                                    <p class="input-label">Store</p>
                                    <el-select v-model="selected_store" v-validate="'required'" :disabled="table_loader"
                                        placeholder="Select Store" filterable class="custom-input store-select-dd"
                                        style="width: 100%" name="Select Store" size="medium" @change="changeStoreId()">
                                        <el-option v-for="(item, store_list_index) in filteredStoreList"
                                            :key="store_list_index" :value="item.id" :label="item.name">
                                            {{ item.name }}
                                        </el-option>
                                    </el-select>
                                    <p>
                                        <span :v-show="errors.has(`Select Store`)" class="text-red-dark text-xs">
                                            {{ errors.first(`Select Store`) }}
                                        </span>
                                    </p>
                                </el-col>

                                <el-col style="margin: 0px 10px;" :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                    <!-- Select week box -->
                                    <p class="input-label">View by -Month</p>
                                    <el-date-picker v-model="selected_month" v-validate="'required'" :disabled="table_loader" size="medium"
                                        :type="dateType" class="custom-input" style="width: 100%"
                                        name="Select Month" placeholder="Pick a Month" :picker-options="monthRangeOptions"
                                        @change="changeStoreDate()">
                                    </el-date-picker>
                                </el-col>


                                <el-col class="block" style="margin: 0px 10px;" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">

                                </el-col>

                            </el-row>
                        </el-col>
                    </el-row>
                </div>

                <!-- Table section start here -->
                <div v-if="!table_loader" class="monthly-sch-view-tbl mt-5">
                    <el-card class="">
                        <!-- Table action header -->
                        <div class="flex items-center justify-between">
                            <div>
                                <!-- <el-dropdown trigger="click" placement="bottom-start">
                            <span class="bulk-edit-scheduler">
                                <el-button class="nymbl-bulk-edit-btn" icon="el-icon-more">Select</el-button>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item style="display: flex; align-items: center;" command="delete_shifts"><i class="el-icon-delete"
                                                        style="margin-right: 10px; color: #e29d5a; font-size:18px;"></i>Delete
                                                </el-dropdown-item>
                                                <el-dropdown-item style="display: flex; align-items: center;" command="weekly_off">
                                                    <i class="el-icon-date" style="margin-right: 10px; color: #e29d5a; font-size:18px;"></i>Weekly
                                                    Off
                                                </el-dropdown-item>
                                                <el-dropdown-item :disabled="isCurrentWeek()" style="display: flex; align-items: center;"
                                                    command="clear_schedule"><i class="el-icon-circle-close"
                                                        style="margin-right: 10px; color: #e29d5a; font-size:18px;"></i>Clear
                                                    Schedule
                                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                            </div>
                            <div class="flex items-center"> <!-- Search By EMP name --> 
                                <!-- <el-alert
                                    v-if="checkAccessLevel().req && Object.keys(schedule_approval_info).length && !schedule_approval_info.latestapprovedon"
                                    :title="schedule_approval_info.latestsavedon ? ('Last sent for approval on ' + moment.utc(schedule_approval_info.latestsavedon, 'YYYY-MM-DD HH:mm:ss').local().format('llll')) : '' "
                                    type="warning"
                                    show-icon class="mr-3">
                                </el-alert>
                                <el-alert
                                v-if="(checkAccessLevel().approve || checkAccessLevel().req) && Object.keys(schedule_approval_info).length"
                                    :title="schedule_approval_info.latestapprovedon ? ('Approved on ' + moment.utc(schedule_approval_info.latestapprovedon, 'YYYY-MM-DD HH:mm:ss').local().format('llll')) : ''"
                                    type="success"
                                    show-icon class="mr-3">
                                </el-alert> -->
                                <el-input
                                    v-model="search_by_employee"
                                    placeholder="Search by employee"
                                    prefix-icon="el-icon-search" style="width: 100%;">
                                </el-input>
                                 
                                
                                <!-- Approval FLow -->
                                <div v-if="checkCompany.is_sb_malaysia">
                                    <BaseButton v-if="checkAccessLevel().req" :disabled="isApproveReqSent" @click="publishMonthlySch('req')"
                                        style="width: 155px;  margin-right: 15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                        size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5 ns-approve-sch-btn">
                                        {{Object.keys(schedule_approval_info).length && (schedule_approval_info.currentstatus === 'approved') ? 'Send For Approval' : 'Send For Approval'}}
                                    </BaseButton>
                                    <BaseButton v-if="checkAccessLevel().approve" @click="publishMonthlySch('approve')"
                                        style="width: 155px;  margin-right: 15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                        size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5 ns-approve-sch-btn">
                                        {{ Object.keys(schedule_approval_info).length && (schedule_approval_info.currentstatus === 'approved') ? 'Approved' : 'Approve Schedule'}}
                                    </BaseButton>
                                </div>

                                <BaseButton @click="publishMonthlySch"
                                    style="width: 110px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                    size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5">
                                    Save
                                </BaseButton>
                                <!-- <BaseButton @click="generateExcelTemplate"
                                    style="width: 250px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                    size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5 ns-excel-btn">
                                    Download Template
                                </BaseButton> -->
                                <el-dropdown trigger="click" class="text-xs" style="margin-left: 10px;"
									@command="publishSchedule">
									<BaseButton
                                        style="width: 110px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                        size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5">
                                        Download <i :class="pdf_loading ? 'el-icon-loading' : 'el-icon-arrow-down'" class="el-icon--right"></i>
                                    </BaseButton>
									<el-dropdown-menu slot="dropdown">
										<!-- <el-dropdown-item command="PRINT">Print schedule</el-dropdown-item> -->
										<el-dropdown-item command="PDF">Download Schedule PDF</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
                                <!-- <el-dropdown trigger="click" class="text-xs" style="margin-left: 10px; margin-right: 45px;"
									@command="importExportSchedule">
									<BaseButton
                                        style="width: 110px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                        size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5 mr-5 ns-excel-btn">
                                        Import schedule <i :class="'el-icon-arrow-down'" class="el-icon--right"></i>
                                    </BaseButton>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="export">Download template</el-dropdown-item>
										<el-dropdown-item command="import">Import schedule</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->
                                <!-- <BaseButton @click="downloadTableAsPDF"
                                    style="width: 110px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;"
                                    size="medium" type="submit" buttonclass="btn p-2 text-xs ml-5">
                                    Publish <i :class="pdf_loading ? 'el-icon-loading' : 'el-icon-arrow-down'" class="el-icon--right"></i>
                                </BaseButton> -->
                            </div>
                        </div>
                        <p v-if="checkCompany.is_sb_malaysia && checkAccessLevel().req && Object.keys(schedule_approval_info).length && !schedule_approval_info.latestapprovedon" class="text-sm font-normal text-right mr-8 mt-1 mb-3">{{ schedule_approval_info.latestsavedon ? ('Last sent for approval on ' + moment.utc(schedule_approval_info.latestsavedon, 'YYYY-MM-DD HH:mm:ss').local().format('llll')) : '' }}</p>
                        <p v-if="checkCompany.is_sb_malaysia && (checkAccessLevel().approve || checkAccessLevel().req) && Object.keys(schedule_approval_info).length" class="text-sm font-normal text-right mt-1 mb-3" style="margin-right: 110px;">{{ schedule_approval_info.latestapprovedon ? ('Approved on ' + moment.utc(schedule_approval_info.latestapprovedon, 'YYYY-MM-DD HH:mm:ss').local().format('llll')) : '' }}</p>

                        <!-- Table start here -->
                        <div>
                            <table class="monthly-sch-tbl w-full mt-2">
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="left-tbl-col">
                                                <h3 class="text-sm font-bold text-center text-black ns-capitalize">  {{ getStoreName(selected_store) }} </h3>
                                            </div>
                                        </th>
                                        <th v-for="(item, dateIndex) in dayListOfMonth" :key="'date-' + dateIndex"
                                            :style="{ width: ((100 - 14) / dayListOfMonth.length) + '%' }"
                                            :class="[(item.day.startsWith('S')) ? 'th-bg-color-dark' : 'th-bg-color']"
                                            class="px-1 py-2 text-white">
                                            <el-popover
                                            placement="top"
                                            class="mx-auto"
                                            width="110"
                                            trigger="hover">
                                            <el-button @click="deleteShiftByDate(item.formatDate)">Delete</el-button>
                                                <div slot="reference" class="mx-auto">
                                                    {{ item.date }} <br>
                                                    {{ item.day }}
                                                </div>
                                            </el-popover>
                                        </th>
                                    </tr>
                                </thead>
                            </table>

                           <div class="ns-sch-tbl-sec-2">
                            <p class="ns-msc-st-header font-semibold">Primary store</p>
                                <!-- !! Optimized table start here -->
                                <MonthlySchedulePlannerTable :search-by-employee="search_by_employee" :selected-month="selected_month" :selected-store="selected_store"
                                    :formatted-scheduler-data="formattedSchedulerData" :shift-last-date="dayListOfMonth[dayListOfMonth.length-1]"
                                    :shift-field-drop-down="shiftFieldDropDown" :day-list-of-month="dayListOfMonth" :month-scheduler-emp-data="monthSchedulerEmpData" :other-shift-data="combinedSecondaryStoreShiftsData" :all-secondary-store-emp-list="all_ss_emp_list" @saveSelectedShift="saveSelectedShift" @formattingShiftAsgData="formattingShiftAsgData" @UpdateSSShifts="UpdateSSShifts" @updatedSchData="updatedSchData">
                                </MonthlySchedulePlannerTable>
                                <!-- !! Optimized table start here -->

                                <!-- Secondary store shifts -->
                                <div v-if="checkCompany.is_sb_malaysia">
                                    <p v-if="formatted_secondaryStore_data.length" class="ns-msc-st-header font-semibold">Loaned Out Employees</p>
                                    <div v-for="store in formatted_secondaryStore_data" :key="store.store_id">
                                        <div class="mt-2 mb-2" style="width: 285px">
                                            <h3 class="text-sm font-bold text-center ns-capitalize">{{ store.store_name }}</h3>
                                        </div>
                                        <MonthlySchedulePlannerTableSS :search-by-employee="search_by_employee" :selected-month="selected_month" :selected-store="store.store_id"
                                            :formatted-scheduler-data="store.emp_data" :shift-last-date="dayListOfMonth[dayListOfMonth.length-1]"
                                            :shift-field-drop-down="store.custom_shifts" :day-list-of-month="dayListOfMonth" :month-scheduler-emp-data="store.emp_data" :primary-store-shifts="updated_sch_data" :other-shift-data="combinedSecondaryStoreShiftsData"
                                            @saveSelectedShift="saveSelectedShift" @formattingShiftAsgData="formattingShiftAsgData" @getSecondaryStoreScheduleDataAll="getSecondaryStoreScheduleDataAll">
                                        </MonthlySchedulePlannerTableSS>
                                    </div>
                               </div>
                                <!-- Secondary store shifts -->
                                
                                <!-- Loaned in stored -->
                                <div v-if="checkCompany.is_sb_malaysia">
                                    <p v-if="formatted_loanedInStore_data.length" class="ns-msc-st-header font-semibold">Loaned In Employees</p>
                                    <div v-for="store in formatted_loanedInStore_data" :key="store.store_id">
                                        <div class="mt-2 mb-2" style="width: 285px">
                                            <h3 class="text-sm font-bold text-center ns-capitalize">{{ store.store_name }}</h3>
                                        </div>
                                        <MonthlySchedulePlannerTableLI :search-by-employee="search_by_employee" :selected-month="selected_month" :selected-store="store.store_id"
                                            :formatted-scheduler-data="store.emp_data">
                                        </MonthlySchedulePlannerTableLI>
                                    </div>
                                </div>
                                <!-- Loaned in stored -->

                           </div>

                            <hr class="my-5" style="border-bottom: 1px solid black;">
                            <!-- Table for custom shifts -->
                            <MonthlyShiftWiseAssignmentTable
                                :formatted-shift-wise-assignment="formattedShiftWiseAssignmentData"
                                @getAllMonthData="getAllMonthData"></MonthlyShiftWiseAssignmentTable>
                        </div>
                        <!-- <BaseButton @click="publishMonthlySch" style="width: 110px;  margin-right:15px; margin-bottom: 10px; margin-top: 10px; float: right;" size="medium" type="submit"
                    buttonclass="btn p-2 text-xs ">
                    Save
                </BaseButton> -->
                        <!-- publishMonthlySch -->
                    </el-card>
                </div>

                <!-- Skeleton structure -->
                <div v-if="table_loader" class="w-full bg-white" style="padding: 20px">
                    <el-skeleton class="scheduler-skeleton-loading" style="width: 100%" :loading="true" animated>
                        <template slot="template">
                            <el-skeleton-item class="mt-3" style="height: 50px; width: 100%;" variant="text" />
                            <el-skeleton-item class="mt-10" style="height: 320px; width: 100%;" variant="text" />
                            <el-skeleton-item class="mt-3" style="height: 320px; width: 100%;" variant="text" />
                        </template>
                    </el-skeleton>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Shift Details" name="shift_details">
                <el-card>
                    <el-row :gutter="20">
                    <el-col :span="24" class="text-right py-2">
                        <el-button size="small" icon="el-icon-plus" class="btn submit-btn p-2 text-xs"
                            @click="addMoreShiftDetails">Add New</el-button>
                    </el-col>
                </el-row>
                <div class="event-table">
                    <!-- Custom Shifts List -->
                    <el-row :gutter="20" type="flex" justify="center pb-4" style="border-bottom: 1px solid #ccc;"
                        class="custom-shifts-table-header">
                        <el-col :span="5" class="text-center font-bold">
                            Shift Name
                        </el-col>
                        <el-col :span="2" class="text-center font-bold">
                            &nbsp;
                        </el-col>
                        <el-col :span="5" class="text-center font-bold">
                            Start Time
                        </el-col>
                        <el-col :span="5" class="text-center font-bold">
                            End Time
                        </el-col>
                        <el-col :span="3" class="text-center font-bold">
                            &nbsp;
                        </el-col>
                    </el-row>

                    <div class="custom-shifts-table__body pt-4" refs="custom_shifts_table__body"
                        id="custom-shifts-table__body">

                        <!-- Values -->
                        <el-row :gutter="20" type="flex" justify="center py-2"
                            v-for="(item, index) in addedShiftPreferences.slice().reverse()"
                            :key="'addedShiftPreferences-' + index">
                            <el-col :span="5" class="text-center font-bold">
                                <el-input placeholder="Enter shift name" v-model="item.name"></el-input>
                            </el-col>
                            <el-col :span="2" class="text-center font-bold">
                                &nbsp;
                            </el-col>
                            <el-col :span="5" class="text-center font-bold">
                                <el-select v-model="item.start_time" filterable placeholder="HH:mm" class="custom-select__input"
                                    :clearable="false" @change="updateToSetTime(9.5, item.start_time, index)">
                                    <el-option v-for="(time, index) in restricted_time_slots_from"
                                        :key="'pref-start-time-' + index" :label="time.formated_time" :value="time.time">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5" class="text-center font-bold">
                                <el-select v-model="item.end_time" filterable placeholder="HH:mm" class="custom-select__input"
                                    :clearable="false" :disabled="checkCompany.is_sb_malaysia">
                                    <el-option v-for="(time, index) in restricted_time_slots_from"
                                        :key="'pref-start-time-' + index" :label="time.formated_time" :value="time.time" :disabled="item.end_time === '00:00:00' && time.time === '00:00:00'">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3" class="text-left pt-2 font-bold" style="font-size: 18px;">
                                <i class="cursor-pointer primary-btn el-icon-delete" @click="deleteCustomShift(index)"></i>
                            </el-col>
                        </el-row>
                        <!-- ./Values -->
                    </div>
                    <!-- ./Custom Shifts List -->


                    <!-- Action Button -->
                    <el-row class="my-2 bg-common" :gutter="20"
                        style="background: white; position:sticky; bottom: 0; right: 0; width: 100%; padding: 8px 0;">
                        <el-col :span="24" class="text-right" style="padding-right: 4rem;">
                            <!-- <el-button size="small" class="btn cancel-btn p-2 text-xs" @click="closeShiftPreferences">
                                Cancel
                            </el-button> -->
                            <el-button size="small" class="btn submit-btn p-2 text-xs" @click="addCustomShift"
                                :style="false ? 'opacity:0.5;cursor:not-allowed;pointer-events: none;' : ''">
                                Update
                            </el-button>
                        </el-col>
                    </el-row>
                    <!-- ./Action Button -->
                </div>
                </el-card>
            </el-tab-pane>
        </el-tabs>
        <!-- Add event dialog -->

        <el-dialog title="Add Event" :visible.sync="addEventVisible" width="60%">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Name <span style="color: red">*</span></p>
                    <!-- v-validate="'max:20' || 'required'" -->
                    <BaseInput v-model.lazy="event_name" v-validate="addEventVisible ? 'required' : ''" class="baseInput"
                        style="width: 100%" custom-class="text-sm  text-amp-input-boxes" type="text" name="eventName" />
                    <p>
                        <span :v-show="errors.has(`eventName`)" class="text-red-dark text-xs">
                            {{ errors.first(`eventName`) }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Type <span style="color: red">*</span></p>
                    <el-select v-model="event_type" v-validate="addEventVisible ? 'required' : ''" name="eventType"
                        style="width: 100%" placeholder="Event Type" @change="eventType(event_type)">
                        <el-option v-for="(item, index) in eventTypeList" :key="index" :value="item.value"
                            :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <p>
                        <span :v-show="errors.has(`eventType`)" class="text-red-dark text-xs">
                            {{ errors.first(`eventType`) }}
                        </span>
                    </p>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Event Category <span style="color: red">*</span></p>
                    <el-select v-model="event_category" v-validate="addEventVisible ? 'required' : ''" name="event Category"
                        style="width: 100%" placeholder="Event Category">
                        <el-option v-for="(item, index) in allEventCategoryList" :key="index" :value="item.id"
                            :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <p>
                        <span :v-show="errors.has(`event Category`)" class="text-red-dark text-xs">
                            {{ errors.first(`event Category`) }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">From <span style="color: red">*</span></p>
                    <el-date-picker v-model="startDateEvent" v-validate="addEventVisible ? 'required' : ''"
                        style="width: 100%" type="date" placeholder="Start Date" name="from date"
                        :picker-options="dateRangeOptions" @change="getOriginalForecast()"></el-date-picker>
                    <p>
                        <span :v-show="errors.has(`from date`)" class="text-red-dark text-xs">
                            {{ errors.first(`from date`) }}
                        </span>
                    </p>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">End Date <span style="color: red">*</span></p>
                    <el-date-picker v-model="endDateEvent" v-validate="addEventVisible ? 'required' : ''"
                        style="width: 100%" type="date" placeholder="End Date" :picker-options="{
                            disabledDate: (date) => {
                                return date < startDateEvent;
                            },
                            firstDayOfWeek: 1,
                        }" :disabled="!startDateEvent" name="to date" @change="getOriginalForecast()"></el-date-picker>
                    <p>
                        <span :v-show="errors.has(`to date`)" class="text-red-dark text-xs">
                            {{ errors.first(`to date`) }}
                        </span>
                    </p>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">Start Time</p>
                    <el-time-select v-model="Start_time_event" :editable="false" style="width: 100%" :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '23:59',
                    }" placeholder="Start Time" :disabled="event_type == 'store_closed'">
                    </el-time-select>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="py-2">End Time</p>
                    <el-time-select v-model="end_time_event" :editable="false" style="width: 100%" :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '23:59',
                    }" placeholder="Start Time" :disabled="event_type == 'store_closed'">
                    </el-time-select>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <p class="py-2">Sales Impact</p>
                    <div class="flex items-center">
                        <el-select v-validate="addEventVisible ? 'required' : ''" v-model="sales_impact" style="width: 100%"
                            name="Sales Impact" placeholder="Sales Impact" :filterabe="true"
                            @change="changeSalesImpact(sales_impact, $event)">
                            <el-option v-for="(item, itemIndex) in salesImpactList" :key="itemIndex" :label="item.title"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <span class="ml-2 cursor-pointer"
                      ><img src="../../../../assets/images/info.png" width="18"
                    /></span> -->
                    </div>
                    <span :v-show="errors.has(`Sales Impact`)" class="text-red-dark text-xs">
                        {{ errors.first(`Sales Impact`) }}
                    </span>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="p-2 flex items-center">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="text-xs mb-1">Original Forecast</p>
                    <div class=" ">
                        <el-input v-model="original_forecast" placeholder="Original Forecast" disabled style="width: 80%;">
                        </el-input>
                    </div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <p class="text-xs mb-1">Updated Forecast</p>
                    <div class=" ">
                        <el-input v-model="updated_forecast" placeholder="Updated Forecast" disabled
                            style="width: 80%;"></el-input>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="flex items-center justify-end pt-2">
                <div class="text-right pt-2 flex items-center ">
                    <BaseButton type="submit" class="w-24 mr-4" buttonclass="btn p-2 text-xs "
                        @click="addEventVisible = false">
                        Cancel
                    </BaseButton>
                    <BaseButton type="submit" class="w-24" buttonclass="btn p-2 text-xs " @click="createNewEvent">
                        Add
                    </BaseButton>
                </div>
            </el-row>
        </el-dialog>

        <!-- Table for Month sch PDF -->
        <table id="month-schedule-print">
            <thead>
                <tr>
                    <th> Emp Name </th>
                    <th> Designation </th>
                    <th v-for="(item,index) in dayListOfMonth" :key="index">{{ item.date + ' ' + formatDate(item.formatDate) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emp, empIndex) in formattedSchedulerData" :key="empIndex">
                    <td>{{ emp.full_name }}</td>
                    <td>{{ emp.designation_info.name }}</td>
                    <td v-for="(shift, shiftIndex) in dayListOfMonth" :key="shiftIndex">
                        <template>
                            {{ getShiftDetails(shift.formatDate, emp.id) }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
        <table id="month-assignment-print">
            <thead>
                <tr>
                    <th> Shift </th>
                    <th> Time </th>
                    <th v-for="(item,index) in dayListOfMonth" :key="index">{{ item.date + ' ' + formatDate(item.formatDate) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(shift_ass, shift_assIndex) in formattedShiftWiseAssignmentData" :key="shift_assIndex">
                    <td>{{ shift_ass.name }}</td>
                    <td>{{ shift_ass.start_time && shift_ass.end_time ? formatTime(shift_ass.start_time) + ' - ' + formatTime(shift_ass.end_time) : '-'  }}</td>
                    <td v-for="(shift, shiftIndex) in dayListOfMonth" :key="shiftIndex">
                        <template v-if="getShiftAssDetails(shift.formatDate, shift_ass.id)">
                            {{ getShiftAssDetails(shift.formatDate, shift_ass.id) }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- Table for Month sch PDF -->
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import LabourPlanningService from "../../../../services/labourPalnningService"
import MonthlySchedulePlannerTable from "./MonthlySchedulePlannerTable.vue";
import MonthlyShiftWiseAssignmentTable from "./MonthlyShiftWiseAssignmentTable.vue";
import MonthlySchedulePlannerTableSS from "./MonthlySchedulePlannerTableSS.vue";
import MonthlySchedulePlannerTableLI from "./MonthlySchedulePlannerTableLI.vue";
import { EventBus } from "../../../../eventBus";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { monthlyScheduleMixin } from "../../../../../mixins/monthlyScheduleMixin"
// const $ = require("jquery");
export default {
    name: 'MonthlySchedulerPlanner',
    components: {
        MonthlySchedulePlannerTable,
        MonthlyShiftWiseAssignmentTable,
        MonthlySchedulePlannerTableSS,
        MonthlySchedulePlannerTableLI
    },
    mixins: [monthlyScheduleMixin],
    data() {
        const self = this;
        return {
            moment: moment,
            days_list_of_month: [],
            activeName: 'month_planner',
            selected_store: '',
            selected_month: '',
            schedulerSelectionMode: 'month',
            dateType: 'month',
            monthRangeOptions: {
                disabledDate(time) {
                    // return time.getTime() < Date.now();
                },
                shortcuts: [{
                    text: 'Day',
                    onClick(picker) {
                        const date = moment(new Date()).format("YYYY-MM-DD");
                        self.$router.push({
                            path: `/day-wise-scheduler/${self.selected_store}/${date}`
                        });
                    },
                }, {
                    text: 'Week',
                    onClick(picker) {
                        const date = moment(new Date()).format("YYYY-MM-DD");
                        self.$router.push({
                            path: `/schedule-planner/`
                        });
                    }
                }, {
                    text: 'Month',
                    onClick(picker) {
                    }
                }],
            },
            dateRangeOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            all_custom_shifts: [],
            links: [],
            search_by_employee: '',
            state1: '',
            state2: '',
            original_forecast: [],
            updated_forecast: [],
            allEventCategoryList: [],
            all_events_data: [],
            addEventVisible: false,
            eventDate: '',
            city: '',
            event_name: '',
            event_type: '',
            event_category: '',
            description: '-',
            sales_impact: '',
            startDateEvent: '',
            Start_time_event: '',
            end_time_event: '',
            endDateEvent: '',
            selectedShiftDate: '',
            addLeaveDialog: false,
            leaveStartDate: null,
            leaveEndDate: null,
            leaveType: null,
            totalLeaveDays: 1,
            leaveDescription: null,
            leaveEmpId: null,
            empLeaveDate: null,
            isChangesOccurred: false,
            isHaveLeave: false,
            eventTypeList: [
                {
                    name: "Internal",
                    value: "internal",
                },
                {
                    name: "External",
                    value: "external",
                },
            ],
            leave_types_list: [
                {
                    value: "privileged_leave",
                    label: "Privileged leave"
                },
                {
                    value: "sick_leave",
                    label: "Sick leave"
                },
                {
                    value: "casual_leave",
                    label: "Casual leave"
                },
                {
                    value: "half_day",
                    label: "Half day"
                },
                {
                    value: "maternity_leave",
                    label: "Maternity leave"
                },
                {
                    value: "paternity_leave",
                    label: "Paternity leave"
                },
                {
                    value: "others",
                    label: "Others"
                }
            ],
            formatted_monthly_scheduler_data: [],
            formatted_monthly_shift_asg_data: [],
            addedShiftPreferences: [
                {
                    "name": "",
                    "description": "",
                    "start_time": "11:00:00",
                    "end_time": "20:30:00"
                }
            ],
            pdf_loading: false,
            updatedData: null,
            shiftTableLoading: false,
            allShiftPreferenceData: [],
            restricted_time_slots_from: [],
            restricted_time_slots_to: [],
            isLoading: false,
            schedule_approval_info: {},
            is_schedule_saved: true,
            updated_sch_data: [],
            is_approve_req_sent: false,
        }
    },
    computed: {
        ...mapState("MonthlySchedulerStore",
            ["scheduler_month",
                "all_store_list",
                "table_loader",
                "month_scheduler_employee_data",
                "month_scheduler_shift_data",
                "month_scheduler_shift_ass_data",
                "all_emp_leaves_data"]),
        dayListOfMonth() {
            let data = [];
            const date = this.selected_month;
            if (date) {
                data = this.getDaysArray(moment(date).format('YYYY'), moment(date).format('MM'));
            }
            return data;
        },
        filteredStoreList() {
            let data = [...this.all_store_list];
            data = data.filter((e) => e.type == 'store');
            return data;
        },
        loadCustomShifts() {
            let custom_shifts = [...this.all_custom_shifts];
            let weekOff = { name: 'OFF', id: 0, }
            custom_shifts.push(weekOff);
            return custom_shifts;
        },
        shiftFieldDropDown() {
            let custom_shifts = [...this.all_custom_shifts];
            let weekOff = { name: 'Week Off', id: 'OFF', }
            let Leave = {name: 'Leave', id: 'LEAVE', }
            // let Delete = {name: 'Clear Shift', id: 'DELETE', }
            custom_shifts.push(weekOff, Leave);
            // custom_shifts.push(Leave);
            // custom_shifts.push(Delete);
            let formatTime = (time) => {return moment(time, "HH:mm:ss").format("hh:mm A")}
            for(let i of custom_shifts) {
                if(i.start_time && i.end_time){
                    i.shift_time = `${formatTime(i.start_time) + ' - ' + formatTime(i.end_time)}`
                }
            }
            return custom_shifts;
        },
        monthSchedulerEmpData() {
            let data = JSON.parse(JSON.stringify(this.month_scheduler_employee_data));

            return data;
        },
        monthSchedulerAssData() {
            let data = JSON.parse(JSON.stringify(this.month_scheduler_shift_ass_data));

            return data;
        },
        monthSchedulerShiftData() {
            var days = JSON.parse(JSON.stringify(this.dayListOfMonth));
            var empData = [...this.monthSchedulerEmpData];
            var result = [];
            if (empData.length) {
                // Prepare keys
                days.map((d) => { d.shift_id = null });
                empData.map((e) => { e.shift_data = days });
                result = empData;
            }

            return result;
        },
        salesImpactList() {
            let tempArr = [];
            for (var x = -100; x <= 101; x++) {
                if (x % 5 == 0) {
                    let obj = {};
                    obj.title = x + "%";
                    obj.value = x;
                    tempArr.push(obj);
                }
            }
            return tempArr;
        },
        formattedSchedulerData() {
            let result = this.formatted_monthly_scheduler_data;
            if (this.search_by_employee) {
                result = result.filter((item) => {
                    return this.search_by_employee.toLowerCase().split(' ').every(v => item.full_name.toLowerCase().includes(v))
                });
            } else {
                result = result;
            }
            return result;
        },
        formattedShiftWiseAssignmentData() {
            return this.formatted_monthly_shift_asg_data;
        },
        customShiftPresent() {
            let localCustomShifts = [...this.addedShiftPreferences];

            if(localCustomShifts.length > 0) {
                if(localCustomShifts.length == 1) {
                    if(localCustomShifts[0].id) {
                        return true;
                    } else {
                        return false
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        shiftPreferencesTypes() {
            let customShiftsCopy = this.addedShiftPreferences.filter(el => el.id && el.name && el.start_time && el.end_time);
            if(customShiftsCopy === undefined) {
                customShiftsCopy = [{
                    "id": null,
                    "name": "Custom",
                    "description": "",
                    "start_time": "00:00:00",
                    "end_time": "09:00:00"
                }];
            } else {
                customShiftsCopy.push({
                    "id": null,
                    "name": "Custom",
                    "description": "",
                    "start_time": "00:00:00",
                    "end_time": "09:00:00"
                });
            }

            return customShiftsCopy;
        },
        checkCompany() {
            // return false;
            return JSON.parse(localStorage.getItem('check_company'));
        },
        isApproveReqSent(){
            let condition = false;
            const last_approve_sent = this.schedule_approval_info.latestsavedon;
            // Want to check is the last_approve_sent time is last 1 hour or not
            if(last_approve_sent){
                let last_approve_sent_time = moment.utc(last_approve_sent, 'YYYY-MM-DD HH:mm:ss').local();
                let current_time = moment();
                let diff = current_time.diff(last_approve_sent_time, 'minutes');
                console.log(diff, 'diff')
                if(diff <= 60 && diff >= 0){
                    condition = true;
                }
            }
            return condition;
        }
    },
    created() {

    },
    mounted() { 
        this.getStoreData();
        this.getEventCategory();
        // Set previous store Id
        this.selected_store = localStorage.getItem('store');
        // For temp
        if (!this.scheduler_month) {
            const preSelectedMonth = localStorage.getItem('scheduler_month');
            let current_month = preSelectedMonth ? preSelectedMonth : moment().format('YYYY-MM-DD');
            this.$store.commit('MonthlySchedulerStore/SET_SCHEDULER_MONTH', current_month)
            this.selected_month = current_month;
        } else {
            this.selected_month = this.scheduler_month
        }
        this.restricted_time_slots_from = this.generateTimeSlots("00:00", "23:30");
        this.restricted_time_slots_to = this.generateTimeSlots("00:00", "23:30");

        EventBus.$on('updateAllMonthlyData', () => {
            this.updateShiftData();
        });

    },
    beforeDestroy(){
      EventBus.$off('closeCopyPasteMode'); 
      EventBus.$off('updateAllMonthlyData');
    },
    methods: {
        ...mapActions("MonthlySchedulerStore", ['getStoreDataAction']),
        ...mapActions("CommonStore",["addDownloadingReportCountAction", "removeDownloadingReportCountAction"]),
        UpdateSSShifts(){
            let from_date = moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD');
            let to_date = moment(this.scheduler_month).endOf('month').format('YYYY-MM-DD');
            let obj = { storeID: this.selected_store, get_all: true, formDate: from_date, toDate: to_date }
            if(this.checkCompany.is_sb_malaysia){
                this.getSecondaryStoreScheduleDataAll(obj);
                // this.getSecondaryStoreScheduleData(obj);
                // this.getSecondaryStoreEmpData(obj);
                // this.getSecondaryStoreCustomShifts(obj);
            }
        },
        updatedSchData(data){
            this.updated_sch_data = data;
        },
        checkAccessLevel(){
            let condition = {approve: false, req: false};
            const level = localStorage.getItem('user_access_level');
            if(level === 'admin' || level === 'super' || level === 'region' || level === 'sub_region'){
                condition.approve = true;
            } else if(level === 'outlet') {
                condition.req = true;
            }
            return condition;
        },
        sendForApproval(){
            let payload = {outlet: this.selected_store, date: moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD')}
            if(this.is_schedule_saved) {
                LabourPlanningService.reqMonthlyScheduleApproval(payload).then((res)=>{
                    this.$notify.success({
                        title: "Success",
                        message: "Schedule updated and sent for approval.",
                    });
                    this.getApproveScheduleInfo();
                }).catch((err)=>{
                    console.log(err, 'err')
                    this.$notify.error({
                        title: 'Error',
                        message: err.status || 'Something went wrong!'
                    });
                })
            }
        },
        updateToSetTime(gap, start_time, index){
            if(!this.checkCompany.is_sb_malaysia){
                return;
            } 
            // Assuming items is an array of objects
            let item = this.addedShiftPreferences.slice().reverse()[index];
            item.end_time = moment(start_time, "HH:mm:ss").add(gap, 'hours').format('HH:mm:ss');
            return item;
        },
        approveSchedule(){
            let payload = {outlet: this.selected_store, date: moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD')}
            if(this.is_schedule_saved) {
                LabourPlanningService.approveMonthlySchedule(payload).then((res)=>{
                    this.$notify.success({
                        title: "Success",
                        message: "Schedule approved successfully.",
                    });
                    this.getApproveScheduleInfo();
                }).catch((err)=>{
                    let errorMessage = JSON.parse(err.response.data).status;
                    this.$notify.error({
                        title: 'Error',
                        message: errorMessage || 'Something went wrong!'
                    });
                })
            }
        },
        getApproveScheduleInfo(){
            let payload = {outlet: this.selected_store, date: moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD')}
            LabourPlanningService.getMonthlyScheduleApproveInfo(payload).then((res)=>{
                this.schedule_approval_info = JSON.parse(res.data);
            }).catch((err)=>{
                console.error(err);
                this.$notify.error({
                    title: 'Oops!',
                    message: 'Something went wrong!'
                });
            })
        },
        publishSchedule(command){
            if(command === 'PDF'){
                this.pdf_loading = true;
                this.addDownloadingReportCountAction('Schedule');
                this.downloadTableAsPDF();
            }
        },
        formatTime(time) {
            if (!time) {
                return '-';
            }
            return moment(time, "HH:mm:ss").format('hh:mm A')
        },
        formatDate(date) {
            if (!date) {
                return '-';
            }
            return moment(date, "YYYY-MM-DD").format('MMM')
        },
        importExportSchedule(command){
            if(command === 'export'){
                EventBus.$emit('generateExcelTemplate');
            } else if(command === 'import') {
                EventBus.$emit('importSchedule', true);
            }
        },
        disableButton() {
            let shiftPreferenceData = this.updatedData;
            let check = shiftPreferenceData.find(el => el.editable == true);
            if(check === undefined) {
                return false;
            } else {
                return true;
            }
        },
        handleClick(tab, event) {
            this.resetWindow();
        },
        resetWindow() {
            this.searchedEmployee = "";
            this.employeesForDelete = [];
            // this.getAllShiftPreferenceData();
            this.getAllCustomShiftNames();
            this.getCustomShiftsData();
        },
        getAllShiftPreferenceData() {
            this.isLoading = true;
             const params = {
                store_id: this.storeId,
                employees: []
            };
            this.shiftTableLoading = true;
            LabourPlanningService.getEmpShiftPreference(params).then(response => {
                this.shiftTableLoading = false;
                 this.allShiftPreferenceData = JSON.parse(response.data);
            }).catch(err => {
                this.shiftTableLoading = false;
                console.error(err);
            }).finally(res => {
                this.isLoading = false;
                this.getStoreStaffInfo();
            });
        },
        generateTimeSlots(start_time_slot, end_time_slot) {
              // calculate 30 mins duration
            let interval = 30;
            let period = "minutes";
            let periods_in_a_day = moment.duration(1, "day").as(period);
            let time_labels = [];

            let start_time = start_time_slot;
            let end_time = end_time_slot;

            let start_time_moment = moment(start_time, "HH:mm");

            for (let i = 0; i < periods_in_a_day; i += interval) {
                start_time_moment.add(i === 0 ? 0 : interval, period);
                let obj = {
                    time: start_time_moment.format("HH:mm:ss"),
                    datetime: start_time_moment.format("YYYY-MM-DD HH:mm:ss"),
                    formated_time: start_time_moment.format("HH:mm"),
                };
                time_labels.push(obj);

                if (end_time == start_time_moment.format("HH:mm")) {
                    break;
                }
            }

            return time_labels;
        },
        getShiftDetails(date,id){
            let shift = '-'
            let shiftData = [...this.formattedSchedulerData];
            
            if(shiftData.length){
                shiftData = shiftData.find((e)=>e.id === id);
                shift = shiftData.shift_data.find((s)=> s.date === date);
                if(shift && Object.keys(shift).length){
                    shift = shift.shift_name;
                }
            }
            return shift;
        },
        getShiftAssDetails(date, id){
            let shift = null;
            let shiftAssData = [...this.formattedShiftWiseAssignmentData];
            if(shiftAssData.length){
                shiftAssData = shiftAssData.find((e)=>e.id === id);
                shift = shiftAssData.all_shift_assignment.find((s)=> moment(s.date).format('YYYY-MM-DD') === date);
                if(shift && Object.keys(shift).length && shift.assigned_count){
                    shift = shift.against_deficit ? (shift.assigned_count + ' D') : (shift.assigned_count+' E')
                } else {
                    shift = null;
                }
            }
            return shift;
        },
        downloadTableAsPDF() {
        try {
                const selected_store = this.all_store_list.find((s)=> s.id === this.selected_store).name;
                const selected_month = moment(this.selected_month).format('LL');
                var currentPage = 1;
                const table = document.getElementById("month-schedule-print");
                const table2 = document.getElementById("month-assignment-print");
                var header = function () {
                    if (currentPage === 1) { // only print the header on the first page
					    currentPage++;
                        doc.setFontSize(10);
                        doc.setTextColor(40);
                        doc.setFontStyle('normal');
                        doc.text(40, 25, `Store name : ${selected_store}`);
                        doc.text(`Crew and Manager Schedule : ${selected_store}`, 400, 25, 'center');
                        doc.text(`Date : ${selected_month}`, 800, 25, 'right');
                        doc.text(`Peak Period Target:____________ Actual___________`, 400, 45, 'center');
                        doc.text(`Report Printed On : ${ moment().format('L, LTS') }`, 800, 45, 'right');
                    }
                };
                var options = {
                    didDrawPage: header,
                    theme: 'plain',
                    margin: { top: 60, left: 5, right: 5 },
                    styles: { lineWidth: 0.7, lineColor: 190, fontSize: 7, cellPadding: 2, halign: 'center' },
                    headStyles: { halign: 'center', fillColor: [255, 255, 255], textColor: 0 },
                    columnStyles: { 0: {cellWidth: 75, halign: 'left'}, 1: {cellWidth: 45, halign: 'left'}, cellWidth: 15,  halign: 'center' }
                };
                var options2 = {
                    theme: 'plain',
                    // willDrawCell: function (data) {
                    //     console.log(data.cell.text[0], data, 'data cell')
                    //     // if (getBreakShirtName.trim() == data.cell.text[0].trim()) {
                    //     //     doc.setFillColor(181, 181, 181);
                    //     //     data.cell.styles.fillColor = "#b5b5b5";
                    //     // }
                    // },
                    margin: { top: 60, left: 5, right: 5 },
                    styles: { lineWidth: 0.7, lineColor: 190, fontSize: 7, cellPadding: 2, halign: 'center' },
                    headStyles: { halign: 'center', fillColor: [255, 255, 255], textColor: 0 },
                    columnStyles: { 0: {cellWidth: 35, halign: 'left'}, 1: {cellWidth: 75, halign: 'left'}, cellWidth: 15,  halign: 'center' }
                };
                // Create a new jsPDF instance
                const doc = new jsPDF({
                    orientation: "landscape", // Set orientation to landscape
                    unit: "pt", // Use points as the unit for the PDF
                });

                var table_data  = doc.autoTableHtmlToJson(table);
                var table_data2  = doc.autoTableHtmlToJson(table2);
                // Generate the PDF from the table
                doc.autoTable(table_data.columns, table_data.data, options);
                doc.autoTable(table_data2.columns, table_data2.data, options2);

                // Save the PDF as "schedule_table.pdf"
                doc.save(`${selected_store + '-' + selected_month}`);
            } catch (error) {
                console.error("Error generating PDF:", error);
                this.pdf_loading = false;
            } finally {
                this.pdf_loading = false;
                // After downloading call loader comeplete action
			    this.removeDownloadingReportCountAction();
            }
        },
        getUpdatedShiftDataAction(payload) {
            let getEmpPayload = { outlet_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate, get_all: true };
            // Before call empty data  
            LabourPlanningService.getUpdatedShiftData(
                getEmpPayload,
                getEmpPayload
            ).then(axios.spread((
                getShiftDataRes,
                getShiftWiseAssDataRes
            ) => {
                if (getShiftDataRes.status == 200 &&
                    getShiftDataRes.status == 200
                ) {
                    let getShiftData = JSON.parse(getShiftDataRes.data);
                    let getShiftWiseAssData = JSON.parse(getShiftWiseAssDataRes.data);
                    this.$store.commit("MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_DATA", getShiftData);
                    this.$store.commit("MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_ASS_DATA", getShiftWiseAssData);
                    // Format data now
                    this.formattingMonthlySchedulerData();
                    this.formattingShiftAsgData();
                }
            })).catch((err) => {
                this.$notify.error({
                    title: 'Error',
                    message: 'Something went wrong!'
                });
                console.error(err);
            });
        },
        updateAssignmentData(payload){
            let getEmpPayload = { outlet_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate, get_all: true };
            LabourPlanningService.getAllMonthlyShiftWiseAss(getEmpPayload).then((res)=>{
                let getShiftWiseAssData = JSON.parse(res.data);
                this.$store.commit("MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_ASS_DATA", getShiftWiseAssData);
                this.formattingShiftAsgData();
            }).catch((err)=>{
                this.$notify.error({
                    title: 'Error',
                    message: 'Something went wrong!'
                });
                console.error(err);
            })
        },
        getEmpDayWiseDataAction(payload) {
            let getEmpPayload = { outlet_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate }
            let getEmpLeavesParams = { store_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate, get_all: true }
            let obj = { storeID: payload.storeID, get_all: true, formDate: payload.formDate, toDate: payload.toDate }
            this.$store.commit('MonthlySchedulerStore/SET_TABLE_LOADER_STATE', true)

            LabourPlanningService.getMonthlySchedulerData(
                getEmpPayload,
                getEmpPayload,
                getEmpPayload,
                getEmpLeavesParams
            ).then(axios.spread((
                getEmpDataRes,
                getShiftDataRes,
                getShiftWiseAssDataRes,
                getLeavesDataRes
            ) => {
                if (getEmpDataRes.status == 200 &&
                    getShiftDataRes.status == 200 &&
                    getShiftWiseAssDataRes.status == 200 &&
                    getLeavesDataRes.status
                ) {
                    this.$store.commit('MonthlySchedulerStore/SET_TABLE_LOADER_STATE', false)
                    let getEmpData = JSON.parse(getEmpDataRes.data);
                    let getShiftData = JSON.parse(getShiftDataRes.data);
                    let getShiftWiseAssData = JSON.parse(getShiftWiseAssDataRes.data);
                    let getLeavesData = JSON.parse(getLeavesDataRes.data);
                    this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_EMP_DATA', getEmpData);
                    this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_DATA', getShiftData);
                    this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_ASS_DATA', getShiftWiseAssData);
                    this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_EMP_LEAVES_DATA', getLeavesData);
                    // Secondary store call
                    if (this.checkCompany.is_sb_malaysia) {
                        this.getSecondaryStoreScheduleDataAll(obj);
                        // this.getSecondaryStoreScheduleData(obj);
                        // this.getSecondaryStoreEmpData(obj);
                        // this.getSecondaryStoreCustomShifts(obj);
                    }
                    // Format data now
                    this.formattingMonthlySchedulerData();
                    this.formattingShiftAsgData();
                }
            })).catch((err) => {
                this.$notify.error({
                    title: 'Error',
                    message: 'Something went wrong!'
                });
                this.$store.commit('MonthlySchedulerStore/SET_TABLE_LOADER_STATE', false)
                console.error(err);
                this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_EMP_DATA', [])
                this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_DATA', [])
                this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_ASS_DATA', [])
                this.$store.commit('MonthlySchedulerStore/SET_MONTH_SCHEDULER_EMP_LEAVES_DATA', [])
            });
        },
        formattingMonthlySchedulerData() {
            let result = [];

            // Create deep copies of necessary data
            const days = JSON.parse(JSON.stringify(this.dayListOfMonth));
            const empData = [...this.monthSchedulerEmpData];
            const shifts = JSON.parse(JSON.stringify(this.month_scheduler_shift_data));
            const sData = JSON.parse(JSON.stringify(this.all_custom_shifts));

            // Add necessary keys to each day
            days.forEach((dd) => {
                dd.against_deficit = null;
                dd.against_shift = null;
                dd.is_excess = null;
                dd.week_off_assigned = null;
                dd.date = dd.formatDate;
            });

            // Format and merge employee data with shifts and days
            result = JSON.parse(JSON.stringify(empData));
            result.forEach(emp => {
                emp.shift_data = shifts.filter((sd) => sd.employee == emp.id);
                let allShifts = _.unionBy(emp.shift_data, days, 'date');
                emp.all_shift_data = _.sortBy(allShifts, ['date']);
            });

            // Set shift names
            result.forEach((r) => {
                r.all_shift_data.forEach((s) => {
                if (s.assigned_shift) {
                    const shiftNameData = sData.find((sd) => sd.id == s.assigned_shift);
                    s.shift_name = shiftNameData ? shiftNameData.name : '-';
                    s.toggle_dropdown = false;
                } else {
                    s.shift_name = s.week_off_assigned ? 'OFF' : s.leave_assigned ? 'L' : '';
                }
                });
            });

            // Store the formatted result in the component data property
            this.formatted_monthly_scheduler_data = result;

            // Return the formatted result
            return result;
        },
        formattingShiftAsgData() {
            let data = [];
            let result = [];
            var days = JSON.parse(JSON.stringify(this.dayListOfMonth));
            var customShifts = [...this.loadCustomShifts];
            let shiftAss = JSON.parse(JSON.stringify(this.monthSchedulerAssData));
            // Formatting data of scheduler
            result = JSON.parse(JSON.stringify(customShifts));
            // shiftAss = shiftAss.map((sa)=> sa.date = sa.date.split('T')[0]);
            result.map(shift => {
                let tempAss = shiftAss.filter((sd) => sd.shift_id == shift.id && days.some((dd) => dd.formatDate == sd.date.split('T')[0]));
                shift.all_shift_assignment = _.sortBy(_.uniq(tempAss, 'date'), ['date']);
            });
            return this.formatted_monthly_shift_asg_data = result;
        },
        changeStoreDate() {
            if (this.schedulerSelectionMode) {
                if (this.schedulerSelectionMode === 'month') {
                    this.$store.commit('MonthlySchedulerStore/SET_SCHEDULER_MONTH', this.selected_month);
                    localStorage.setItem('scheduler_month', this.selected_month);
                    this.getAllMonthData();
                    if(this.checkCompany.is_sb_malaysia) {
                        this.getApproveScheduleInfo();
                    }
                } else if (this.schedulerSelectionMode === 'week') {
                    this.$router.push({
                        path: `/scheduler/planner`
                    });
                } else if (this.schedulerSelectionMode === 'date') {
                    const date = moment(this.selected_month).format("YYYY-MM-DD");
                    this.$router.push({
                        path: `/day-wise-scheduler/${this.selected_store}/${date}`
                    });
                }
            }
        },
        getDaysArray(year, month) {
            var monthIndex = month - 1; // 0..11 instead of 1..12
            var names = ['Su', 'M', 'T', 'W', 'Th', 'Fr', 'Sa'];
            var date = new Date(year, monthIndex, 1);
            var result = [];
            while (date.getMonth() == monthIndex) {
                result.push({ date: date.getDate(), day: names[date.getDay()], formatDate: moment(date).format('YYYY-MM-DD') });
                date.setDate(date.getDate() + 1);
            }
            return result;
        },
        changeStoreId() {
            localStorage.setItem('store', this.selected_store)
            if (this.selected_store) {
                this.getAllMonthData();
            }
            if(this.checkCompany.is_sb_malaysia) {
                this.getApproveScheduleInfo();
            }
        },
        getAllMonthData() {
            if (this.selected_store && this.scheduler_month) {
                let from_date = moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD');
                let to_date = moment(this.scheduler_month).endOf('month').format('YYYY-MM-DD');
                let obj = { storeID: this.selected_store, get_all: true, formDate: from_date, toDate: to_date }
                this.getCustomShiftsData();
                this.getEvents();
                this.getEmpDayWiseDataAction(obj);
            }
        },
        updateShiftData() {
            if (this.selected_store && this.scheduler_month) {
                let from_date = moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD');
                let to_date = moment(this.scheduler_month).endOf('month').format('YYYY-MM-DD');
                let obj = { storeID: this.selected_store, get_all: true, formDate: from_date, toDate: to_date }
                // this.getUpdatedShiftDataAction(obj);
                this.updateAssignmentData(obj);

                if(this.checkCompany.is_sb_malaysia){
                    this.getSecondaryStoreScheduleDataAll(obj);
                    // this.getSecondaryStoreScheduleData(obj);
                    // this.getSecondaryStoreEmpData(obj);
                }
            }
        },
        getStoreData() {
            LabourPlanningService.getAllStoreData().then((res) => {
                let data = JSON.parse(res.data);
                data = data.filter((d) => d.type == 'store');
                let selectStore = localStorage.getItem("store");
                if (!selectStore && data.length) {
                    this.selected_store = data[0].id;
                    localStorage.setItem('store', data[0].id);
                }

                data.filter(
                    function (store) {
                        if (store.id == this.selected_store) {
                            this.city = store.city;
                        }
                    }.bind(this)
                );

                this.$store.commit('MonthlySchedulerStore/SET_STORE_LIST_DATA', data)
                if (this.selected_store) {
                    this.getAllMonthData();
                    this.getAllCustomShiftNames();
                }
            }).catch((err) => {
                console.error(err)
            }).finally(()=>{
                if(this.checkCompany.is_sb_malaysia) {
                    this.getApproveScheduleInfo();
                }
            });

            // Get secondary store outlet list
            // if(this.checkCompany.is_sb_malaysia){
            //     LabourPlanningService.getAllStoreDataCluster().then((res)=>{
            //         let data = JSON.parse(res.data);
            //         this.all_cluster_store_list = data;
            //     }).catch((err)=>{
            //         console.error(err);
            //     })
            // }
        },
        getEvents() {
            let from_date = moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD');
            let to_date = moment(this.scheduler_month).endOf('month').format('YYYY-MM-DD');
            let params = { outlet: this.selected_store, get_all: true, from_date: from_date, to_date: to_date, get_all: true }
            LabourPlanningService.getEvents(params).then((res) => {
                let data = JSON.parse(res.data);
                this.all_events_data = [...data];
            }).catch((err) => {
                console.error(err)
            });
        },
        isHaveAnyEvent(date) {
            let allEvents = [...this.all_events_data];
            let eventsDate = [];
            allEvents.map((ev) => {
                if (moment(date, 'YYYY-MM-DD') >= moment(ev.start_date, 'YYYY-MM-DD') && moment(date, 'YYYY-MM-DD') <= moment(ev.end_date, 'YYYY-MM-DD')) {
                    eventsDate.push(date);
                }
            });
            console.log(eventsDate.includes(date))
            return eventsDate.includes(date);
        },
        saveSelectedShift(empId, shift, selected_sId, type) {
            let payload = [
                {
                    store_id: this.selected_store,
                    employee: empId,
                    date: shift.date
                }
            ];
            // If clear shift
            if (type == 'clear_shift') {
                this.clearShiftOfEmp(empId, shift.date)
            } else if (type == 'leave') {
                payload[0].leave_assigned = selected_sId;
                payload[0].week_off_assigned = false;
                payload[0].assigned_shift = null;
                this.saveShiftDataOfEmp(payload);
            } else if (type == 'shift') {
                payload[0].leave_assigned = false;
                payload[0].week_off_assigned = selected_sId == 'OFF' ? true : false;
                payload[0].assigned_shift = selected_sId == 'OFF' ? null : selected_sId;
                this.saveShiftDataOfEmp(payload);
            }
        },
        saveShiftDataOfEmp(payload) {
            LabourPlanningService.saveAllMonthlyShiftsData(payload).then((res) => {
                this.isChangesOccurred = true;
                this.updateShiftData();
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                EventBus.$emit('clearShiftId', true);
            });
        },
        clearShiftOfEmp(empId, date) {
            let payload = { employee_id: empId, date: date, outlet_id: this.selected_store }
            LabourPlanningService.clearEmployeeShift(payload).then((res) => {
                // this.$notify.success({
                //     title: 'Success',
                //     message: 'Shift deleted'
                // });
                this.isChangesOccurred = true;
                this.updateShiftData();
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                this.selected_sId = '';
            });
        },
        getCustomShiftsData() {
            LabourPlanningService.getAllCustomShifts(this.selected_store).then((res) => {
                let data = JSON.parse(res.data);
                this.all_custom_shifts = JSON.parse(JSON.stringify(data));
            }).catch((err) => {
                console.error(err)
            });
        },
        publishMonthlySch(isFor) {
            let from_date = moment(this.scheduler_month).startOf('month').format('YYYY-MM-DD');
            let to_date = moment(this.scheduler_month).endOf('month').format('YYYY-MM-DD');
            let payload = { outlet_id: this.selected_store, start_date: from_date, end_date: to_date }
            // console.log(payload, 'payload')
            if(isFor === 'req'){
                this.$confirm('Do you wish to submit the schedule for approval?', 'Submit For Approval', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    LabourPlanningService.publishMonthlyPlanner(payload).then((res) => {
                        this.sendForApproval();
                    }).catch((err) => {
                        console.error(err);
                    }).finally(() => {
                    });
                });
            } else {
                LabourPlanningService.publishMonthlyPlanner(payload).then((res) => {
                    if(isFor === 'approve'){
                        this.approveSchedule();
                    } else {
                        this.$notify.success({
                            title: "Success",
                            message: "Schedule published.",
                        });
                    }
                }).catch((err) => {
                    console.error(err);
                    this.isChangesOccurred = false;
                }).finally(() => {
                    this.isChangesOccurred = false;
                });
            }
        },
        openEventPopup(eDate) {
            this.addEventVisible = true;
            this.startDateEvent = eDate;
            this.endDateEvent = eDate;
        },
        async getOriginalForecast() {

            let filters = {
                countries: [],
                regions: [],
                subregions: [],
                outlets: this.selected_store ? [this.selected_store] : [],
            }

            let params = {
                filters: filters,
                start_date: this.eventDate ? moment(this.eventDate).format('YYYY-MM-DD') : '',
                end_date: this.eventDate ? moment(this.eventDate).format('YYYY-MM-DD') : ''
            }

            if (this.eventDate && this.eventDate) {
                let forecat_res = await this.getOriginalForecastNetworkCallBack(params);

                if (forecat_res.status == 200) {
                    let res = JSON.parse(forecat_res.data);
                    // console.log(res);
                    this.original_forecast = res.original_qty;
                    this.updated_forecast = res.adjusted_qty;
                }
            }
        },

        getOriginalForecastNetworkCallBack(params) {
            return serverAddr
                .post("/forecast/total_transactions_aggregate/", params)
                .then(response => {
                    return response
                })
                .catch(err => {
                    console.error(error);
                });
        },
        getEventCategory() {
            LabourPlanningService.getEventyCategory()
                .then((response) => {
                    this.allEventCategoryList = JSON.parse(response.data);
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        changeSalesImpact(old_sales_impact, new_sales_impact) {
            this.$confirm(`Sales Impact % will adjust your transactions forecast by ${new_sales_impact}% for selected dates`, "Alert", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                dangerouslyUseHTMLString: true
            })
                .then(() => {
                    this.sales_impact = new_sales_impact;

                    let percentage = this.sales_impact != null && this.original_forecast ? (this.original_forecast / 100) * this.sales_impact : null;

                    this.updated_forecast = (percentage + this.original_forecast).toFixed();
                })
                .catch(() => {
                    this.sales_impact = old_sales_impact;
                });
        },
        createNewEvent() {
            let params = {
                name: this.event_name
                    .toLowerCase()
                    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase())),
                start_date: moment(this.startDateEvent).format("YYYY-MM-DD"),
                end_date: moment(this.endDateEvent).format("YYYY-MM-DD"),
                start_time: this.Start_time_event
                    ? this.Start_time_event + ":00"
                    : "00:00:00",
                end_time: this.end_time_event
                    ? this.end_time_event + ":00"
                    : "00:00:00",
                countries: [],
                regions: [],
                subregions: [],
                stores: [{ id: this.selected_store }],
                category: this.event_category,
                description: this.description,
                impact_sales: this.sales_impact,
            };

            this.$validator.validateAll().then((result) => {
                if (result) {
                    LabourPlanningService.createNewEvent(params)
                        .then((response) => {
                            if (response.status === 201) {
                                let res = JSON.parse(response.data);
                                this.addEvntVisible = false;
                                this.$notify.success({
                                    title: "Success",
                                    message: "Event Created Successfully",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.addEventVisible = false;
                        }).finally(() => {
                            this.addEventVisible = false;
                            this.getEvents();
                        })
                }
            });
        },
        // Shift details methods\
        addMoreShiftDetails() {
            this.addedShiftPreferences.push({
                "name": "",
                "description": "",
                "start_time": "11:00:00",
                "end_time": "20:30:00"
            });
        },
        addCustomShift() {
            let params = this.addedShiftPreferences.filter(el => el.name && el.start_time && el.end_time);

            let valueArr = params.map(function(item){ return item.name });
            let isDuplicate = valueArr.some(function(item, idx){ 
                return valueArr.indexOf(item) != idx 
            });

            // Add store key
            params.map((p)=> {
                p.store = this.selected_store
            });

            if(isDuplicate) {
                this.$notify.error({
                    title: "Duplicate found!",
                    message: "Shift name already exists",
                });
            } else {
                if(params && params.length) {
                    LabourPlanningService.addCustomShift(params)
                    .then(response => {
                        this.getAllCustomShiftNames();
                        this.$notify.success({
                            title: "Success!",
                            message: "Shift updated",
                        });
                    }).catch(error => {
                        console.error(error);
                    });
                } else {
                    this.$notify.error({
                        title: "Empty Data!",
                        message: "Please add atleast one custom shift",
                    });
                }
            }
        },
        getAllCustomShiftNames() {
            LabourPlanningService.getAllCustomShifts(this.selected_store)
            .then(response => {
                let responseData = JSON.parse(response.data);
                if(responseData.length) {
                    this.addedShiftPreferences = [...responseData];
                } else {
                    this.addedShiftPreferences = [
                        {
                            "name": "",
                            "description": "",
                            "start_time": "11:00:00",
                            "end_time": "20:30:00"
                        }
                    ];
                }
            }).catch(error => {
                console.error(error.response.data);
            });
        },
        deleteCustomShift(elementIndex) {
            const siftPreferencesCopy = [...this.addedShiftPreferences.slice().reverse()];
            const deletedItem = siftPreferencesCopy[elementIndex];
            if(deletedItem.id) {
                const params = {
                    "custom_shift": deletedItem.id
                };
                LabourPlanningService.deleteCustomShift(params)
                .then(response => {
                    this.$notify.success({
                        title: "Success!",
                        message: "Shift deleted",
                    });
                }).catch(error => {
                    console.error(error);
                }).finally(result => {
                    this.getAllCustomShiftNames();
                });
            } else {
                this.$delete(siftPreferencesCopy, elementIndex);
                this.addedShiftPreferences = [...siftPreferencesCopy.slice().reverse()];this.$notify.success({
                    title: "Success!",
                    message: "Shift deleted",
                });
                if(this.addedShiftPreferences.length == 0) {
                    this.getAllCustomShiftNames();
                }
            }
        },
        updateCustomShiftPreferenceData(weeklyPreferenceIndex, shiftPreferenceIndex, customShiftId) {
            const localData = this.filteredShiftData[weeklyPreferenceIndex];
            let actualIndex = this.updatedData.findIndex(el => el.id == localData.id);
            if(actualIndex !== -1) {
                let updatedSingleData = this.updatedData[actualIndex];
                if(customShiftId != null) {
                    let customShiftObj = this.addedShiftPreferences.find(el => el.id == customShiftId);
                    if(customShiftObj !== undefined) {
                        updatedSingleData.shift_preferences[shiftPreferenceIndex].custom_shift_id = customShiftObj.id ? customShiftObj.id : null;
                        updatedSingleData.shift_preferences[shiftPreferenceIndex].custom_shift_name = customShiftObj.name;
                        updatedSingleData.shift_preferences[shiftPreferenceIndex].preferred_end_time = customShiftObj.end_time;
                        updatedSingleData.shift_preferences[shiftPreferenceIndex].preferred_start_time = customShiftObj.start_time;
                        this.updatedData[actualIndex] = updatedSingleData;
                    }
                }
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChangesOccurred) {
            this.$confirm('Do you wish to continue without saving changes?', 'Warning', {
                confirmButtonText: 'YES',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                next();
            }).catch(() => {
                next(false);
                this.path = to.path
            });
        } else {
            next();
        }
    }

}
</script>

<style lang="scss">
@import './MonthlyScheduler.scss';
@import '../storeSettings/storeDetails/StoreDetails.scss';
@import '../schedulePlanner/shiftPreference/shiftPreference.scss';
</style>
<style>
.MonthlySchedulerPlanner{
    position: relative;
}
.MonthlySchedulerPlanner .el-button--primary:focus,
.el-button--primary:hover {
    background: #fff;
    border-color: #e29d5a !important;
    color: #e29d5a !important;
}

.el-button--primary {
    color: #fff;
    background-color: #e29d5a;
    border-color: #e29d5a;
}

.action-btn-for-sch {
    height: 32px !important;
    padding: 7px 5px !important;
    line-height: normal !important;
    font-size: 12px !important;
    border-width: 1px !important;
}

.el-button--primary {
    color: #fff;
    background-color: #e29d5a !important;
    border-color: #e29d5a !important;
}

.month-sch-dd-field {
    width: 200px !important;
}

.shiftDeleteOpt {
    color: #f57171;
    background: #ffe8e8;
}
.MonthlySchedulerPlanner .el-tabs__item.is-active {
    color: #e29d5a;
}
.MonthlySchedulerPlanner .el-tabs__item:hover {
    color: #e29d5a;
}
.MonthlySchedulerPlanner .el-tabs__active-bar {
    background-color: #e29d5a;
}
#month-schedule-print, #month-assignment-print{
    display: none;
}
.ns-excel-btn{
    width: 150px !important;
}
.ns-approve-sch-btn{
    background-color: #38c172 !important;
    border-color: #38c172 !important;
}
.ns-approve-sch-btn:hover{
    background-color: #fff !important;
    color: #38c172 !important;
    border-color: #38c172 !important;
}
</style>